import DefaultLayout from "@/layouts/default";
import dynamic from "next/dynamic";
import "@/styles/globals.css";
import MetaTags from "../components/Head/MetaTags";

const Snackbar = dynamic(() => import("@/components/utils/Snackbar"), {
  ssr: false,
});

function App({ Component, pageProps }) {
  const { title, data, websiteData, metaTags, url, ...restProps } = pageProps;

  return (
    <>
      <MetaTags
        title={title || websiteData?.website?.title}
        keywords={
          metaTags?.keywords || websiteData?.website?.metaTags?.keywords
        }
        description={
          metaTags?.ogDescription ||
          websiteData?.website?.metaTags?.ogDescription
        }
        image={metaTags?.ogImage || websiteData?.website?.metaTags?.ogImage}
        url={url}
      />
      <DefaultLayout websiteData={websiteData}>
        <Component
          {...{
            websiteData: websiteData,
            data: data,
            url: url,
            ...restProps,
          }}
        />
      </DefaultLayout>
      <Snackbar />
    </>
  );
}

export default App;
